import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import P1 from '../../assets/images/profile_av.svg'
import { Link } from 'react-router-dom';
import { fetchReferrals } from '../../Redux/Actions/dataActions';

function UserDetailcard({ user, dashboardData, referrals, fetchReferrals, loading }) {
    useEffect(() => {
        if (!referrals && !loading) {
            fetchReferrals();
        }
    }, [referrals, fetchReferrals, loading]);

    // Use dashboard account data if available, otherwise fall back to auth user
    const account = dashboardData?.account || user || {};
    const accountType = account.accountType || 'Personal';
    const vipStatus = account.vipStatus || account.isVip ? 'VIP' : null;
    const commissionRate = referrals?.commissionRate || referrals?.commission || '40';
    const referralCode = referrals?.referralCode || account.referralCode || '';
    const twitterLinked = account.socialLinks?.twitter || false;

    if (loading) {
        return (
            <div className="row g-3 mb-3">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="row g-3 mb-3">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row g-3 align-items-center">
                            <div className="col-md-6 col-lg-6 col-xl-3">
                                <div className="d-flex">
                                    <img className="avatar rounded-circle" src={P1} alt="profile"/>
                                        <div className="flex-fill ms-3">
                                            <p className="mb-0"><span className="font-weight-bold">{account?.name || 'User'}</span></p>
                                            <small className="">{account?.email || 'user@example.com'}</small>
                                        </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-3">
                                <div className="d-flex flex-column">
                                    <span className="text-muted mb-1">Mobile: {account?.mobileNumber || account?.phone || 'N/A'}</span>
                                    <span className="small text-muted flex-fill text-truncate">Status: {account?.status || 'N/A'}</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-2">
                                <div className="d-flex-inline">
                                    <span className="badge bg-careys-pink mb-1">{accountType}</span>
                                    {account?.role && (
                                        <span className="small text-muted d-flex align-items-center"><i className="icofont-diamond px-1 fs-5 color-lightyellow "></i> {account.role.toUpperCase()}</span>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4">
                                {/* Commission and social links removed - not in API response */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    dashboardData: state.data?.dashboard?.data || state.data?.dashboard,
    referrals: state.data?.referrals,
    loading: state.data?.loading?.dashboard || state.data?.loading?.referrals || false,
});

export default connect(mapStateToProps, { fetchReferrals })(UserDetailcard);